module.exports = __webpack_public_path__ + "img/ring_y_e_0_null@2x.1f0f6edc.png";